var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMusicoff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_4212_15832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 10.7451V18.5C11 19.4283 10.631 20.3182 9.97461 20.9746C9.31823 21.631 8.42826 22 7.5 22C6.57174 22 5.68177 21.631 5.02539 20.9746C4.36901 20.3182 4 19.4283 4 18.5C4 17.5717 4.36901 16.6818 5.02539 16.0254C5.68177 15.369 6.57174 15 7.5 15C8.03998 15 8.55002 15.1199 9 15.3398V7.51562L11 10.7451ZM23 16.5C23 17.0623 22.8629 17.6097 22.6104 18.1006L19.4531 13.001C19.4687 13.0008 19.4844 13 19.5 13C20.04 13 20.55 13.1199 21 13.3398V7.46973L16.6074 8.4043L14.9482 5.72461L23 4V16.5Z",
    fill: "#2E1654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7365 20.2034L19.3356 22.3091L7.9995 4.00022L11.4004 1.89453L22.7365 20.2034Z",
    fill: "#2E1654"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_4212_15832",
    x: 0,
    y: 0,
    width: 27,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.21758
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.211765 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "shape",
    result: "effect1_innerShadow_4212_15832"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicoff);
export default __webpack_public_path__ + "static/media/musicoff.7592880ced8b36c1c34f6bcbd4e05a60.svg";
export { ForwardRef as ReactComponent };